import classNames from 'classnames';
import React from 'react';
import { Spinner } from 'react-bootstrap';

import './OverlaySpinner.scss';

interface IProps {
  className?: string;
  removeBgColor?: boolean;
}
const OverlaySpinner = ({ className, removeBgColor }: IProps) => {
  return (
    <div
      className={classNames(
        'OverlaySpinner d-flex w-100 h-100 align-items-center justify-content-center',
        className,
        { 'OverlaySpinner--remove-bg-color': removeBgColor },
      )}
    >
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
};

export default OverlaySpinner;
